import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import ResponceComponent from '../components/responses.component';
import { selectListItems } from '../../../../../../redux/library/selector';
import { chapterPost } from '../../../../../../redux/chapter/posts/action';
import { chapterResponses } from '../../../../../../redux/chapter/responses/action';
import { selectChapterResponsesQueryItems } from '../../../../../../redux/chapter/responses/selector';
import { selectChapterPostListItems } from '../../../../../../redux/chapter/posts/selector';

const ChaptersResponse = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const responseQuery = useSelector(selectChapterResponsesQueryItems);
  const postItems = useSelector(selectChapterPostListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles, setMediaFiles] = useState<any>([])
  const libraryData = useSelector(selectListItems)

  const [selectedResponse, setSelectedResponse] = useState<any>({
    "Name": "",
    "DisplayOrder": 0,
    "CommunityId": 0

  });

  const fetchForumGroupsQueryById = () => {
    dispatch(chapterResponses.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/post/responses/query`,
      entity: 'chapterResponses',
      jsonData: {
        Context: {},
        Records: [
          {

            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedResponse({ ...selectedResponse, [field]: event });
  }
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }
  useEffect(() => {
    dispatch(chapterPost.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/posts/list`,
      entity: 'chapter',
      jsonData: {

        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
        "Pagination": {
          "PageNumber": 1,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc"
        }

      }
    })).then(() => {
      if (parmas?.id > 0) {
        fetchForumGroupsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedResponse(responseQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const responseData = {

      "Id": selectedResponse?.Id || 0,
      "Content": selectedResponse?.Content,
      "ChapterPostId": selectedResponse?.ChapterPostId,
      "MediaMappings": {
        "MediaFiles": [],
        "Templates": []
      },

    }
    if (parmas?.id > 0) {
      await dispatch(chapterResponses.resetAction({ actionType: 'update' }))
      await dispatch(chapterResponses.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/post/responses`,
        entity: 'chapterResponses',
        jsonData: {
          Context: {},
          Records: [
            responseData
          ]

        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(chapterResponses.resetAction({ actionType: 'create' }))
      await dispatch(chapterResponses.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/community/chapter/topic/post/responses`,
        entity: 'chapterResponses',
        jsonData: {
          Context: {},
          Records: [
            responseData
          ]

        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/onesp/chapters/comments');
  }

  return (
    <>
      {responseQuery?.isLoading ? <PageLoader /> :
        <ResponceComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedResponse={selectedResponse}
          back={back}
          handleFormSubmit={handleFormSubmit}
          post={postItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
          libraryData={libraryData?.result?.ChapterTopicType}
        />
      }
    </>
  );
}

export default ChaptersResponse;
